import { render, staticRenderFns } from "./TabOverTime.vue?vue&type=template&id=5c708866&"
import script from "./TabOverTime.vue?vue&type=script&lang=js&"
export * from "./TabOverTime.vue?vue&type=script&lang=js&"
import style0 from "./TabOverTime.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports